import { useCallback, useState } from "react";
import styled from "styled-components";

// Internal Imports
import { COLORS } from "../../constants/colors";
import DayOption from "../DayOption/DayOption";


// Interface
interface Props {
    value: string;
    onChange: any;
}

const InputWrapper = styled.div<any>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${COLORS.white_color2(1)};
    border-radius: 5px;
    border: 1px solid ${COLORS.black_text_color3};
    min-height: 38px;
    padding-left: 8px;
    padding-right: 8px;
    width: 100%;

    :hover .DI_dayContainer{
        display: block;
    }
    

    .DI_icon {
        color: ${COLORS.black_text_color3};
        cursor: pointer;
        padding: 0px 0px 0px 10px;
    }

    /* .DI_icon:act˚ */

    .DI_daySelected {
        display: flex;
        cursor: pointer;
        justify-content: space-between;
        background-color: aliceblue;
        padding: 0px 15px 0px 15px;
        margin: 3px 8px 3px 0px;
        border: 0.2px solid ${COLORS.black_text_color3};
        border-radius: 50px;
    }

    .DI_containerDaySelected {
        display: flex;
        flex-wrap: wrap;
        padding: 5px 0px 5px 0px;
        position: relative;
        width: inherit;
        min-height: 38px;
    }

    .DI_dayContainer {
        background-color: var(--white_color1);
        box-shadow: 0px 2px 5px var(--black_back_color5);
        padding: 5px 0px 5px 0px;
        position: absolute;
        max-height: 130px;
        overflow-y: auto;
        width: 109.5%;
        z-index: 1;
        top: 104%;
        left: -7px;
        display: none;
}

    .DI_dayContainer::-webkit-scrollbar {
        display: none;
    }
    `;


const DayInput = ({ value, onChange }: Props) => {
    const [dayContainerVisible, setDayContainerVisible] = useState<boolean>(false);

    const DAYS: any = {
        "0": 'Domingo',
        "1": 'Lunes',
        "2": 'Martes',
        "3": 'Miercoles',
        "4": 'Jueves',
        "5": 'Viernes',
        "6": 'Sábado',
    }

    const transformValueToDays = () => {
        const days = Object.values(DAYS);
        const dayOption: any[] = days.map((day, index) => ({ dayName: day, index: index, selected: value[index] === '1' ? true : false }));
        return dayOption;
    };

    const dayClick = (dayIndex: number) => {
        let valueCopy = value.split('');
        let dayStatus = valueCopy[dayIndex];
        let daynewStatus = dayStatus === '1' ? '0' : '1';
        valueCopy[dayIndex] = daynewStatus;
        onChange(valueCopy.join(''));
    }

    return (
        <InputWrapper>
            <div className="DI_containerDaySelected">
                {value.split('').map((item, index) => ({ val: item, position: index })).filter(item => item.val === '1').map((day) =>
                    <div className="DI_daySelected" onClick={() => dayClick(day.position)}>
                        {DAYS[day.position]}
                        <nav className="DI_icon"><i className="fa-solid fa-xmark"></i></nav>
                    </div>
                )}

                <div className="DI_dayContainer">
                    {transformValueToDays().map((day) => (
                        <DayOption
                            key={day.dayName}
                            day={day.dayName}
                            selected={day.selected}
                            onClick={() => dayClick(day.index)}
                        />
                    ))

                    }
                </div>
            </div>


            <nav className="DI_icon"><i className="fa-solid fa-chevron-down"></i></nav>

        </InputWrapper>
    );
}



export default DayInput;